import {Nullable} from '../../../../../app/TypeHelpers'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES} from '../../../../../CodeMaster'
import * as React from 'react'
import {ReactNode} from 'react'
import PPSelect, {OptionProps} from '../../../../shared/forms/PPSelect'
import {numberOrNull} from '../../../../../stringHelper/stringHelpers'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import { Box, InputAdornment } from '@mui/material';
import styled from 'styled-components'
import PPNumericField from '../../../../shared/forms/PPNumericField'
import equal from 'fast-deep-equal'
import {isNoSelect, NoSelectedValue, valueOrNoSelected} from '../../../../../componentHelper/selectHelper'
import {SelectChangeEvent} from '@mui/material/Select'

interface EndOfTimeZoneInputWithMaxTimeProps {
    hour: Nullable<HOURS>
    minute: Nullable<RESERVATION_TIME_UNIT_MINUTES>
    selectableHours: HOURS[]
    maxReservationTime: Nullable<number>
    maxReservationTimeUpperLimit: Nullable<number>
    onChangeEndHour: (endHour: HOURS) => void
    onChangeMaxTime: (maxTime: Nullable<number>) => void
    disabledEndHour?: boolean
}

export class EndOfTimeZoneInputWithMaxTime extends React.Component<EndOfTimeZoneInputWithMaxTimeProps> {

    constructor(props: Readonly<EndOfTimeZoneInputWithMaxTimeProps>) {
        super(props)

        this.handleChangeHour = this.handleChangeHour.bind(this)
        this.handleChangeMaxTime = this.handleChangeMaxTime.bind(this)
    }

    shouldComponentUpdate(nextProps: Readonly<EndOfTimeZoneInputWithMaxTimeProps>): boolean {
        return !(this.props === nextProps || equal(this.props, nextProps))
    }

    handleChangeHour(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === undefined) {
            return
        }
        const value: string = `${event.target.value}`
        if (isNoSelect(value)) {
            return
        }
        this.props.onChangeEndHour(HOURS.codeToEnumConstants(value))
    }

    handleChangeMaxTime(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.onChangeMaxTime(numberOrNull(event.target.value as string))
    }

    render(): ReactNode {
        const {
            hour, minute, selectableHours, maxReservationTime, maxReservationTimeUpperLimit, disabledEndHour,
        } = this.props

        const hourValue: string = valueOrNoSelected(hour)
        const minuteValue: string = minute === null ? '' : minute.value
        const isUnsetHour: boolean = (selectableHours.length === 0)
        const selectHourDatas: OptionProps[] = isUnsetHour
            ? [{label: '', value: NoSelectedValue}]
            : selectableHours.map(item => {
                return {label: item.label, value: item.value}
            })

        return (
            <RowFlexContainer>
                <Box minWidth={'68px'}>
                    <RowFlexContainer>
                        <label>
                            <RowFlexContainer>
                                <PPSelect
                                    required={!isUnsetHour}
                                    data={selectHourDatas}
                                    value={hourValue}
                                    disabled={isUnsetHour || disabledEndHour}
                                    onChange={this.handleChangeHour}
                                />
                                時
                            </RowFlexContainer>
                        </label>
                    </RowFlexContainer>
                </Box>
                <Box minWidth={'48px'}>
                    {minuteValue}分
                </Box>
                <label>
                    <RowFlexContainer>
                        最大
                        <StyledNumericField
                            InputProps={{
                                inputProps: {
                                    min: 1,
                                    max: maxReservationTimeUpperLimit || 23,
                                },
                                endAdornment: <InputAdornment position="end">時間まで</InputAdornment>,
                            }}
                            value={maxReservationTime || ''}
                            disabled={isUnsetHour}
                            onChange={this.handleChangeMaxTime}
                        />
                    </RowFlexContainer>
                </label>
            </RowFlexContainer>
        )
    }
}

const StyledNumericField = styled(PPNumericField)`
  width: 120px;
  min-width: 120px!important;
`
